import {Component, EventEmitter, Input, Output} from '@angular/core'
import {MediaInterface} from '../../interfaces'


@Component({
  selector: 'dmmp-access-filter-image',
  templateUrl: './access-filter-image.component.html'
})
export class AccessFilterImageComponent {

  @Input() data
  @Input() identifier
  @Output() page = new EventEmitter()
  medias: MediaInterface[] = [
    {style: 'large', media: '(min-width:421px)'},
  ]
}
